import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { SpinnerService } from './spinner.service';
import { Dbutils } from './db-utils';

@Injectable({
    providedIn: 'root'
})
export class LoaderService {
    customer: BehaviorSubject<any> = new BehaviorSubject(null)
    _customer:any;
    constructor(private Dbutils: Dbutils, public spinnerService: SpinnerService) {
        new Promise(async resolve => {
            const placeInfo = await this.Dbutils.branchIsExist();
            this.customer.next(placeInfo)
            this._customer=placeInfo;
            // this.spinnerService.hide();
        });
    }

    public getCustomerDetails(): Observable<any> {
        return this.customer.asObservable();
    }

    public getCustomer():any{
        return this._customer;
    }

}